import React from "react";
import Icon from "storybookComponents/Icon"
import Loader from "storybookComponents/Loader"


export default (props) => {
  const [loading, setLoading] = React.useState(true)
  const [index, setIndex] = React.useState(0);


  React.useEffect(() => {
    setIndex(0)
    props.indexChangeCallback(0)
  }, [])


  React.useEffect(() => {
    const frame = document.getElementById("Iframe");
    if (!frame) return
    // Adjusting the iframe height onload event 
    frame.onload = () => {
      // set the height of the iframe as  
      // the height of the iframe content 
      frame.style.height =
        (frame.contentWindow.document.body.scrollHeight + 100) + 'px';
      setLoading(false)
    }
  })


  const prevView = () => {
    setIndex(index - 1);
    props.indexChangeCallback(index - 1)
  }

  const nextView = () => {
    setIndex(index + 1);
    props.indexChangeCallback(index + 1)
  }
  return (
    <div className={props.classes.mainPreviewContainer}>
      {
        loading && <div className={props.classes.loader}><Loader /></div>
      }
      {
        Array.isArray(props.srcDoc) ? index > 0 ?
          <div className={props.classes.arrowIcon} onClick={prevView}>
            <Icon type="icon-left-arrow" />
          </div> :
          <div className={props.classes.arrowIconNull}>
          </div> : null
      }
      <div>
        <iframe id="Iframe" {...props} srcDoc={Array.isArray(props.srcDoc) ? props.srcDoc[index] : props.srcDoc} width={props.dimesions} className={props.classes.iFrameCanvas} />
      </div>
      {
        Array.isArray(props.srcDoc) ? index < props.srcDoc.length - 1 ?
          <div className={props.classes.arrowIcon} onClick={nextView}>
            <Icon type="icon-right-arrow" />
          </div> :
          <div className={props.classes.arrowIconNull}>
          </div>
          : null
      }
    </div >
  )
}
